import { queryOptions } from '@tanstack/react-query'
import { employeeRequest } from '@/shared/api'
import { EmployeeListSchema, EmployeeResponseSchema } from '../model/types'

export const employeeKeys = {
  all: ['employee'] as const,
  list: (q: string, activeOnly: boolean) => ['employee', 'list', q, activeOnly] as const,
  detail: (id: string) => ['employee', 'detail', id] as const,
}

export interface EmployeesFilter {
  q?: string
  activeOnly?: boolean
}

export function employeesQueryOptions({ q = '', activeOnly = true }: EmployeesFilter = {}) {
  return queryOptions({
    queryKey: employeeKeys.list(q, activeOnly),
    queryFn: async () => {
      // Wire: page/size + is_active (строковый enum "true"/"false"); текстового
      // фильтра у бэкенда нет — q применяется на клиенте.
      const body = await employeeRequest<unknown>({
        method: 'GET',
        path: '/employees',
        query: { size: 100, is_active: activeOnly ? 'true' : undefined },
      })
      const items = EmployeeListSchema.parse(body).data ?? []
      const needle = q.trim().toLowerCase()
      if (!needle) return items
      return items.filter(
        (e) => e.full_name.toLowerCase().includes(needle) || e.email.toLowerCase().includes(needle),
      )
    },
  })
}

export function employeeQueryOptions(id: string) {
  return queryOptions({
    queryKey: employeeKeys.detail(id),
    queryFn: async () => {
      const body = await employeeRequest<unknown>({ method: 'GET', path: `/employees/${id}` })
      return EmployeeResponseSchema.parse(body).data
    },
  })
}
